import React from 'react';
export function RasciPage() {
  return <div className="h-full w-full pb-20 md:pb-0" data-id="element-1407">
      <div className="mb-4" data-id="element-1408">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1409">RASCI</h1>
        <p className="text-gray-600" data-id="element-1410">Matrice de responsabilités</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" style={{
      height: 'calc(100vh - 180px)'
    }} data-id="element-1411">
        <iframe src="https://constructiongauthier.somtechsolutions.ca/" className="w-full h-full border-0" title="RASCI Matrix" allow="fullscreen" data-id="element-1412" />
      </div>
    </div>;
}